import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper';
// import useBannerList from '../../hooks/useBannerList';
import ShopBannerCard_ from './ShopBannerCard_';
import axios from 'axios';
import { apiUrl, bannerImgUrl, goodsImgUrl } from '../../common/urls';

const BannerSwiper = ({ id, type }) => {
  const [list, setList] = useState([]);

  const getData = async () => {
    const result = await axios.get(apiUrl + '/api/v2/banners', {
      params: { type },
    });

    setList(result.data.list);
  };

  useEffect(() => {
    getData();
  }, [type]);

  console.log(list);

  return (
    list.length > 0 && (
      <div className="relative">
        <Swiper
          id="banner-swiper"
          className={type === 'main' ? 'm_top_visual' : 'svisual_swiper'}
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={600}
          slidesPerView={1}
          pagination={{
            clickable: true,
            type: 'fraction',
            el: `#banner-swiper-pagination-${id}`,
          }}
          navigation={{
            nextEl: `#banner-swiper-button-next-${id}`,
            prevEl: `#banner-swiper-button-prev-${id}`,
          }}
          resistance={true}
          resistanceRatio={0}
          loop={true}
        >
          {list.map((banner) => {
            return (
              <SwiperSlide key={`banner-${banner.idx}`}>
                <ShopBannerCard_ banner={banner} />
              </SwiperSlide>
            );
          })}
          <div
            id={`banner-swiper-pagination-${id}`}
            className="swiper-pagination"
          />
        </Swiper>
        <div
          id={`banner-swiper-button-next-${id}`}
          className="swiper-button-next"
        />
        <div
          id={`banner-swiper-button-prev-${id}`}
          className="swiper-button-prev"
        />
      </div>
    )
  );
};

export default BannerSwiper;
